import { ComponentType, forwardRef, createElement } from 'react';

export function withDefaults<P extends object>(
  Component: ComponentType<P>,
  defaultProps: Partial<P>
) {
  const Wrapped = forwardRef<unknown, P>((props, ref) => {
    // Using createElement to avoid complex type issues with JSX and ref forwarding
    // The type assertion is safe because:
    // 1. We're using forwardRef which properly handles refs
    // 2. We're merging defaultProps with props correctly
    // 3. StyledComponents (our main use case) accept refs
    return createElement(Component as ComponentType<P & { ref?: unknown }>, {
      ref,
      ...defaultProps,
      ...props,
    } as P & { ref?: unknown });
  });
  
  // Copy display name for better debugging
  Wrapped.displayName = `WithDefaults(${Component.displayName || Component.name || 'Component'})`;
  
  return Wrapped;
}
